/* ============================================================
   B&M Spring Pin / Roll Pin Size Chart — table logic
   Renders an INCH view (ASME B18.8.2, verbatim from the source
   chart) and a METRIC view (B&M verified Pintool guide data),
   switched by a unit toggle, with live search in both views.
   ============================================================ */
(function () {
  'use strict';

  // INCH — all inches, verbatim from spring-pin-chart.txt. pt: recommended tool.
  // dec, frac, goRing (A · max go-ring gage), dstar (D* · avg Ø), bmax (B · max Ø),
  // cnom (C · slot gap nom), holeMin, holeMax, wall.
  var INCH = [
    { pt: 'PT-062', dec: '.062', frac: '1/16', goRing: '.069', dstar: '.066', bmax: '.059', cnom: '.011', holeMin: '.062', holeMax: '.065', wall: '.012' },
    { pt: 'PT-078', dec: '.078', frac: '5/64', goRing: '.086', dstar: '.083', bmax: '.075', cnom: '.014', holeMin: '.078', holeMax: '.081', wall: '.018' },
    { pt: 'PT-094', dec: '.094', frac: '3/32', goRing: '.103', dstar: '.099', bmax: '.091', cnom: '.018', holeMin: '.094', holeMax: '.097', wall: '.022' },
    { pt: 'PT-125', dec: '.125', frac: '1/8',  goRing: '.135', dstar: '.131', bmax: '.122', cnom: '.024', holeMin: '.125', holeMax: '.129', wall: '.028', flag: true },
    { pt: 'PT-156', dec: '.156', frac: '5/32', goRing: '.167', dstar: '.162', bmax: '.151', cnom: '.028', holeMin: '.156', holeMax: '.160', wall: '.032' },
    { pt: 'PT-187', dec: '.187', frac: '3/16', goRing: '.199', dstar: '.194', bmax: '.182', cnom: '.036', holeMin: '.187', holeMax: '.192', wall: '.040' },
    { pt: null,     dec: '.219', frac: '7/32', goRing: '.232', dstar: '.226', bmax: '.214', cnom: '.042', holeMin: '.219', holeMax: '.224', wall: '.048' },
    { pt: 'PT-250', dec: '.250', frac: '1/4',  goRing: '.264', dstar: '.258', bmax: '.245', cnom: '.042', holeMin: '.250', holeMax: '.256', wall: '.050' },
    { pt: null,     dec: '.312', frac: '5/16', goRing: '.328', dstar: '.321', bmax: '.306', cnom: '.060', holeMin: '.312', holeMax: '.318', wall: '.062' },
    { pt: null,     dec: '.375', frac: '3/8',  goRing: '.392', dstar: '.385', bmax: '.368', cnom: '.060', holeMin: '.375', holeMax: '.382', wall: '.077' },
    { pt: null,     dec: '.437', frac: '7/16', goRing: '.456', dstar: '.448', bmax: '.430', cnom: '.060', holeMin: '.437', holeMax: '.445', wall: '.077' },
    { pt: null,     dec: '.500', frac: '1/2',  goRing: '.521', dstar: '.513', bmax: '.485', cnom: '.060', holeMin: '.500', holeMax: '.510', wall: '.094' }
  ];

  // METRIC — B&M verified data. øG migrated VERBATIM from B&M's legacy Pintool
  // Guide Size page; dec = exact mm→inch; hole = ISO 286 H12 upper tolerance
  // (+0.10 mm ≤3 mm / +0.12 mm >3–6 mm). 5 tooled sizes only (PT-2MM…PT-6MM).
  // nom = nominal mm, dec = decimal Ø (in), hole = recommended hole H12 (mm),
  // gmin/gmax = guide bore øG (in) min/max.
  var METRIC = [
    { pt: 'PT-2MM', nom: '2', dec: '.0787', hole: '2.00–2.10', gmin: '.097', gmax: '.101' },
    { pt: 'PT-3MM', nom: '3', dec: '.1181', hole: '3.00–3.10', gmin: '.140', gmax: '.145' },
    { pt: 'PT-4MM', nom: '4', dec: '.1575', hole: '4.00–4.12', gmin: '.183', gmax: '.187' },
    { pt: 'PT-5MM', nom: '5', dec: '.1969', hole: '5.00–5.12', gmin: '.222', gmax: '.226' },
    { pt: 'PT-6MM', nom: '6', dec: '.2362', hole: '6.00–6.12', gmin: '.266', gmax: '.270' }
  ];

  var COLS = { inch: 10, metric: 5 };
  var FOOT = {
    inch: 'All dimensions in inches · D* = average diameter · chamfer features optional',
    metric: 'Metric in mm with decimal-inch equivalents · hole = ISO 286 H12 · øG = guide bore (in)'
  };

  function boot() {
    var root = document.querySelector('[data-bmchart]');
    if (!root) return;
    var PRODUCT_URL = root.getAttribute('data-product-url') || '/products/spring-pin-insertion-tool';

    // PT# -> live variant id, emitted by the section from all_products (keyed by SKU).
    // Used to deep-link each tool cell straight to its variant (?variant=<id>).
    var variantMap = {};
    var mapEl = root.querySelector('[data-pt-variant-map]');
    if (mapEl) {
      try { variantMap = JSON.parse(mapEl.textContent || '{}'); }
      catch (e) { console.warn('[bm-chart] could not parse variant map', e); }
    }
    var table = root.querySelector('[data-size-table]') || root.querySelector('.spc-table');
    var tbody = root.querySelector('tbody');
    var search = root.querySelector('[data-search]');
    var countEl = root.querySelector('[data-count]');
    var footEl = root.querySelector('[data-tbl-foot]');
    var unitBtns = root.querySelectorAll('[data-unit-toggle] button');
    var state = { q: '', unit: 'inch' };

    function esc(s) { return String(s).replace(/[<>&"]/g, ''); }

    function toolCell(pt, flag) {
      if (!pt) return '<span class="na">—</span>';
      var id = variantMap[pt];
      var href = PRODUCT_URL + (id ? '?variant=' + id : '');
      return '<a href="' + href + '">' + pt + '</a>' + (flag ? '<span class="spc-tag">Flagship</span>' : '');
    }

    function matchInch(r, q) {
      return (r.frac + ' ' + r.dec + ' ' + (r.pt || '') + ' ' + r.holeMin + ' ' + r.holeMax)
        .toLowerCase().indexOf(q) !== -1;
    }
    function matchMetric(r, q) {
      // match on mm value (2 / 2mm / 2 mm), decimal-inch, hole, and PT part number
      return (r.pt + ' ' + r.nom + ' mm ' + r.nom + 'mm ' + r.dec + ' ' + r.hole)
        .toLowerCase().indexOf(q) !== -1;
    }

    function rowInch(r) {
      var tr = document.createElement('tr');
      if (r.flag) tr.className = 'flag';
      tr.innerHTML =
        '<td class="pin">' + r.dec + '</td>' +
        '<td class="frac">' + r.frac + '</td>' +
        '<td class="g-hole">' + r.holeMin + '</td>' +
        '<td class="g-hole">' + r.holeMax + '</td>' +
        '<td>' + r.goRing + '</td>' +
        '<td>' + r.dstar + '</td>' +
        '<td>' + r.bmax + '</td>' +
        '<td>' + r.cnom + '</td>' +
        '<td>' + r.wall + '</td>' +
        '<td class="tool">' + toolCell(r.pt, r.flag) + '</td>';
      return tr;
    }
    function rowMetric(r) {
      var tr = document.createElement('tr');
      tr.innerHTML =
        '<td class="tool">' + toolCell(r.pt, false) + '</td>' +
        '<td class="pin">' + r.nom + ' mm</td>' +
        '<td class="frac">' + r.dec + '</td>' +
        '<td class="g-hole">' + r.hole + '</td>' +
        '<td>' + r.gmin + ' / ' + r.gmax + '</td>';
      return tr;
    }

    function render() {
      var q = state.q.trim().toLowerCase();
      var metric = state.unit === 'metric';
      var data = metric ? METRIC : INCH;
      var rows = data.filter(function (r) {
        if (!q) return true;
        return metric ? matchMetric(r, q) : matchInch(r, q);
      });
      tbody.innerHTML = '';
      if (!rows.length) {
        var er = document.createElement('tr');
        er.innerHTML = '<td colspan="' + COLS[state.unit] + '" class="spc-norows">No sizes match "' +
          esc(state.q) + '". Try a fraction (1/8), a decimal (.250), a metric size (3mm) or a part no. (PT-125).</td>';
        tbody.appendChild(er);
      } else {
        rows.forEach(function (r) { tbody.appendChild(metric ? rowMetric(r) : rowInch(r)); });
      }
      if (countEl) countEl.textContent = rows.length + ' / ' + data.length + ' sizes';
      if (footEl) footEl.textContent = FOOT[state.unit];
    }

    function setUnit(u) {
      if (u !== 'inch' && u !== 'metric') return;
      state.unit = u;
      if (table) table.setAttribute('data-unit', u);
      Array.prototype.forEach.call(unitBtns, function (b) {
        var on = b.getAttribute('data-unit') === u;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      render();
    }

    Array.prototype.forEach.call(unitBtns, function (b) {
      b.addEventListener('click', function () { setUnit(b.getAttribute('data-unit')); });
    });
    if (search) search.addEventListener('input', function () { state.q = search.value; render(); });

    setUnit('inch');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
